export enum BetType {
    TPBTie,
    TPBPlayerAWin,
    TPBPlayerBWin,
    TPBPlayerAPairPlus,
    TPBPlayerBPairPlus,
    TPB6CardBonus,
    TPBMaxBet,
}
